import { type PublicOptionResponse } from "./publicOptions.api";
import { useGetCategoryOptions } from "./useGetCategoryOptions";
import { useGetInterestOptions } from "./useGetInterestOptions";
import { useGetNeighborhoodOptions } from "./useGetNeighborhoodOptions";

interface UsePublicEventOptionsReturn {
  neighborhoodOptions: PublicOptionResponse[];
  fetchNeighborhoodOptions: () => Promise<void>;
  categoryOptions: PublicOptionResponse[];
  fetchCategoryOptions: () => Promise<void>;
  interestOptions: PublicOptionResponse[];
  fetchInterestOptions: () => Promise<void>;
}

export const usePublicEventOptions = (organizationId?: string): UsePublicEventOptionsReturn => {
  const { neighborhoodOptions, fetchNeighborhoodOptions } = useGetNeighborhoodOptions(organizationId);
  const { categoryOptions, fetchCategoryOptions } = useGetCategoryOptions();
  const { interestOptions, fetchInterestOptions } = useGetInterestOptions();

  return {
    neighborhoodOptions,
    fetchNeighborhoodOptions,
    categoryOptions,
    fetchCategoryOptions,
    interestOptions,
    fetchInterestOptions,
  };
};
